import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import CampaignOutlinedIcon from "@mui/icons-material/CampaignOutlined";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { Link } from "react-router-dom";
import { useAdminOutreach } from "../../hooks/useAdminOutreach";

export default function OutreachList() {
  const { data: outreachList, isLoading, error } = useAdminOutreach();
  const items = outreachList || [];

  return (
    <div className="mt-[28px]">
      <div className="flex items-center gap-2 mb-[14px]">
        <WarningAmberIcon className="text-good-wine" style={{ fontSize: "22px" }} />
        <h3 className="font-crimson text-[22px] font-normal text-rodeo-black m-0">
          Outreach Needed
        </h3>
        <span className="text-[12px] font-bold text-good-wine bg-good-wine-4 rounded-full px-[10px] py-[2px]">
          {items.length}
        </span>
      </div>

      <div className="flex flex-col gap-3">
        {isLoading ? (
          <div className="animate-pulse h-16 bg-smoke rounded-[10px]" />
        ) : error ? (
          <div className="text-good-wine p-[18px] bg-good-wine-bg border border-good-wine-4 rounded-[10px]">
            Error loading outreach accounts.
          </div>
        ) : items.length === 0 ? (
          <div className="flex items-center gap-2 text-graphite text-[14px] bg-clear-dust border border-smoke rounded-[10px] p-[18px]">
            <CheckCircleIcon className="text-good-sage" style={{ fontSize: "20px" }} />
            No Pro accounts need outreach right now.
          </div>
        ) : (
          items.map((item) => (
            <div
              key={item.orgId}
              className="flex items-center justify-between gap-4 bg-good-wine-bg border border-good-wine-4 border-l-[3px] border-l-good-wine rounded-[10px] p-[16px_18px] flex-wrap"
            >
              <div>
                <div className="flex items-center gap-[10px] text-[16px] font-bold text-rodeo-black">
                  {item.orgName}
                  {item.isPro && (
                    <span className="text-[10px] font-bold tracking-[0.5px] uppercase text-good-wine bg-white border border-good-wine-4 rounded-full px-[9px] py-[2px]">
                      Pro
                    </span>
                  )}
                </div>
                <div className="flex flex-col gap-[6px] mt-2">
                  <div className="flex items-start gap-[7px] text-[13px] text-graphite leading-[1.45]">
                    {item.trigger === "A" ? (
                      <CampaignOutlinedIcon
                        className="text-good-wine shrink-0 mt-[1px]"
                        style={{ fontSize: "16px" }}
                      />
                    ) : (
                      <CalendarMonthOutlinedIcon
                        className="text-good-wine shrink-0 mt-[1px]"
                        style={{ fontSize: "16px" }}
                      />
                    )}
                    {item.reasonText}
                  </div>
                </div>
              </div>
              <div className="flex items-center gap-4 flex-wrap">
                <div className="flex flex-col leading-[1.25] text-right">
                  <span className="text-[10px] font-bold uppercase tracking-[0.5px] text-graphite">
                    Account lead
                  </span>
                  <span className="text-[14px] font-bold text-rodeo-black">
                    {item.accountLeadName || "Unassigned"}
                  </span>
                </div>
                <Link
                  to={`/users-orgs?orgId=${item.orgId}`}
                  className="inline-flex items-center gap-[5px] bg-white border border-good-wine-4 rounded-lg px-[14px] py-[9px] font-lato text-[13px] font-bold text-good-wine whitespace-nowrap hover:border-good-wine hover:bg-good-wine-4 transition-colors"
                >
                  View account <ArrowForwardIcon style={{ fontSize: "16px" }} />
                </Link>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}
